<template>
    <div class="bg-[#161923] py-6 relative">
      <div class="max-w-7xl mx-auto flex justify-end px-6">
        <button
          @click="scrollToTop"
          class="bg-yellow-400 text-black w-10 h-10 flex items-center justify-center rounded-full hover:bg-yellow-300 transition shadow-lg"
          aria-label="Voltar ao topo"
        >
          <ArrowUp class="w-5 h-5" />
        </button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ArrowUp } from 'lucide-vue-next'
  
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  </script>